import { readState } from "@/__main__/app-state.mjs";
import { getLocale } from "@/util/i18n-helper.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export const useLocalizedChampions = (set) => {
  const locale = getLocale();
  const state = useSnapshot(readState);
  if (!set || !state.tft[set]?.localizedUnits) return {};
  const result = state.tft[set]?.localizedUnits?.[locale];
  return result && !(result instanceof Error) ? result : null;
};
